import {Countries} from '../../../lib/constants/countries';

export {Countries};

export const CountriesList = [
  'US',
  ...Object.entries(Countries)
    .filter(([code]) => code !== 'US')
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([code]) => code),
];

/**
 * Get the two-letter country code from a country name.
 * Returns undefined if not found.
 */
export const getCountryCode = (name) => {
  if (!name) return undefined;
  const entry = Object.entries(Countries).find(([, countryName]) => countryName === name);
  return entry?.[0];
};

/**
 * Get the country name from a two-letter country code.
 * Returns undefined if not found.
 */
export const getCountryName = (code) => {
  if (!code) return undefined;
  return Countries[code];
};
